import { useGet } from '../../../sharedModules/hooks/useQuery';

const EMAIL_REVIEW_PENDING_COUNT_URL = '/vendors/outlook_emails/pending_count';

export function useEmailReviewPendingCount() {
  return useGet<{ count: number }>({
    url: EMAIL_REVIEW_PENDING_COUNT_URL,
  });
}
